import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { enableDebugTools } from '@angular/platform-browser';
// import * as Sentry from '@sentry/angular-ivy';
// import { Integrations } from '@sentry/tracing';

// Sentry.init({
//   dsn: 'https://ee7ce85d2d224abfaf8647d4650d096c@o350219.ingest.sentry.io/5531888',
//   integrations: [
//     new Integrations.BrowserTracing({
//       tracingOrigins: ['localhost', 'https://yourserver.io/api'],
//       routingInstrumentation: Sentry.routingInstrumentation,
//     }),
//   ],

//   // We recommend adjusting this value in production, or using tracesSampler
//   // for finer control
//   tracesSampleRate: 1.0,
// });

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then((appRef: any) => enableDebugTools(appRef))
  .catch(err => console.log(err));

